module.exports = __webpack_public_path__ + "img/img14.fca7414a.svg";